// Etiquetas de status/situação (Aberto, Vencida, Pendente…) no tamanho do
// texto da tela — o Badge padrão do Chakra é pequeno demais, principalmente
// no celular. Usado na lista, no detalhe e no plano de ação.
export const STATUS_BADGE_STYLE = {
  fontSize: 'sm',
  px: '2',
  py: '1',
  borderRadius: 'md',
} as const;
